<template>
  <swiper-slide class="swiper2">
    <head-bar :main_title="main_title"></head-bar>
    <div class="contanier">
      <div class="flowL">
        <div class="trend">
          <div class="title">
            <h3>趋势分析</h3>
            <span>月趋势</span>
          </div>
          <div id="page1_chart1"></div>
        </div>
        <div class="source">
          <div class="title">
            <h3>来源分析</h3>
            <span>来源占比</span>
          </div>
          <div id="page1_chart2"></div>
        </div>
      </div>
      <div class="flowC">
        <div class="top">
          <!-- <p>今日流量 / 次</p> -->
          <div class="num">
            <div class="num_wrap">
              <span>今日流量(次):</span>
              <div class="numbox">
                <ul v-for="(item, index) in ulArr" :key="index">
                  <li v-for="(list, key) in numArr" :key="key">{{ list }}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div id="page1_map"></div>
        <ul class="bottom">
          <li v-for="(item, index) in dataList" :key="index">
            <h3>
              {{ item.num }}<i>{{ item.unit }}</i>
            </h3>
            <span>{{ item.name }}</span>
          </li>
          <!-- <li class="list1">
            <h3>17.6<i>亿</i></h3>
            <span>日平均数量</span>
          </li>
          <li class="list2">
            <h3>122.8<i>亿</i></h3>
            <span>周累计数据</span>
          </li>
          <li class="list3">
            <h3>7.87<i>%</i></h3>
            <span>周同比增长↑</span>
          </li>
          <li class="list4">
            <h3>8.65<i>%</i></h3>
            <span>月增长率↑</span>
          </li>
          <li class="list5">
            <h3>13.8<i>亿</i></h3>
            <span>月平均数据量</span>
          </li>
          <li class="list6">
            <h3>549<i>亿</i></h3>
            <span>月累计数据量</span>
          </li> -->
        </ul>
      </div>
      <div class="flowR">
        <div class="region">
          <div class="title fr">
            <h3>地域分析</h3>
            <span>热门城市TOP10</span>
          </div>
          <div class="clear"></div>
          <div id="page1_chart3"></div>
        </div>
        <div class="terminal">
          <div class="title fr">
            <h3>终端分析</h3>
            <span>终端占比</span>
          </div>
          <div class="clear"></div>
          <div id="page1_chart4"></div>
        </div>
      </div>
    </div>
  </swiper-slide>
</template>
<script>
import echarts from "echarts";
import { resizeFun, fontchange } from "../util/fontchange";
import { echartsCancelLoop } from "../util/echarts-auto-tooltip";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import headBar from "../components/headBar.vue";
import "swiper/css/swiper.min.css";
export default {
  name: "flowData",
  components: {
    swiper,
    swiperSlide,
    headBar
  },
  data() {
    return {
      main_title: require("../assets/title1.png"),
      ulArr: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
      numArr: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", ","],
      translateNum: "",
      dataList: [
        {
          num: "10.35亿+",
          name: "覆盖人群"
        },
        {
          num: '27亿+',
          name: "活跃设备覆盖"
        },
        {
          num: '100万+',
          name: "活跃应用覆盖"
        },
        {
          num: '500亿+',
          name: "每日识别"
        },
        {
          num: '500+',
          name: "行为种类覆盖"
        },
        {
          num: '30000+',
          name: "标签总量"
        }
      ]
    };
  },
  mounted() {
    this.page1_chart1();
    this.page1_chart2();
    this.page1_chart3();
    this.getData();
    this.translateNum1();
    this.page1_map();
    this.page1_chart4();
    // this.getRandomNum();
    this.randomNum();
  },
  methods: {
    randomNum(maxNum, minNum, decimalNum) {
      /***************************************
       * 生成从minNum到maxNum的随机数。
       * 如果指定decimalNum个数，则生成指定小数位数的随机数
       * 如果不指定任何参数，则生成0-1之间的随机数。
       *
       * @minNum：[数据类型是Integer]生成的随机数的最小值（minNum和maxNum可以调换位置）
       * @maxNum：[数据类型是Integer]生成的随机数的最大值
       * @decimalNum：[数据类型是Integer]如果生成的是带有小数的随机数，则指定随机数的小数点后的位数
       *
       ****************************************/
      var max = 0,
        min = 0;
      minNum <= maxNum
        ? ((min = minNum), (max = maxNum))
        : ((min = maxNum), (max = minNum));
      switch (arguments.length) {
        case 1:
          return Math.floor(Math.random() * (max + 1));
          break;
        case 2:
          return Math.floor(Math.random() * (max - min + 1) + min);
          break;
        case 3:
          return (Math.random() * (max - min) + min).toFixed(decimalNum);
          break;
        default:
          return Math.random();
          break;
      }
    },
    getRandomNum() {
      let that = this;
      let num1 = this.randomNum(16, 18, 2);
      let num2 = this.randomNum(110, 130, 2);
      let num3 = this.randomNum(6, 8, 2);
      let num4 = this.randomNum(7, 9, 2);
      let num5 = this.randomNum(12, 14, 2);
      let num6 = this.randomNum(520, 550, 2);
      that.dataList[0].num = num1;
      that.dataList[1].num = num2;
      that.dataList[2].num = num3;
      that.dataList[3].num = num4;
      that.dataList[4].num = num5;
      that.dataList[5].num = num6;
    },
    page1_chart1() {
      var dataArr = [];
      var data = new Date();
      var year = data.getFullYear();
      data.setMonth(data.getMonth(), 1); //获取到当前月份(需+1),设置月份
      for (var i = 0; i < 6; i++) {
        data.setMonth(data.getMonth() - 1); //每次循环一次 月份值减1
        var m = data.getMonth() + 1;
        m = m < 10 ? "0" + m : m;
        dataArr.push(data.getFullYear() + "." + m);
      }
      // console.log(dataArr);
      dataArr = dataArr.reverse();

      let myChart = this.$echarts.init(document.getElementById("page1_chart1"));
      var data = {
        // xData: ["2021.10", "2021.11", "2021.12", "2022.1", "2022.2", "2022.3"]
        xData: dataArr
      };
      let option = {
        grid: {
          left: "0",
          right: "0%",
          top: "25%",
          bottom: "0",
          containLabel: true
        },
        tooltip: {
          show: true,
          trigger: "axis",
          axisPointer: {
            type: "line",
            lineStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(255,255,255,0)" // 0% 处的颜色
                  },
                  {
                    offset: 0.5,
                    color: "rgba(255,255,255,1)" // 100% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(255,255,255,0)" // 100% 处的颜色
                  }
                ],
                global: false // 缺省为 false
              }
            }
          },
          formatter: function(params) {
            var relVal = params[0].name;
            for (var i = 0, l = params.length; i < l; i++) {
              relVal +=
                "<br/>" +
                params[i].marker +
                params[i].seriesName +
                " : " +
                params[i].value +
                "亿";
            }
            return relVal;
          },
          textStyle: {
            fontSize: fontchange(0.14)
          }
        },
        legend: {
          icon: "roundRect", //图例形状
          top: "15",
          left: "right",
          itemWidth: 16, // 图例图形宽度
          itemHeight: 8, // 图例图形高度
          itemGap: fontchange(0.15),
          textStyle: {
            color: "#fff",
            fontSize: fontchange(0.13)
          }
        },
        xAxis: [
          {
            axisLine: {
              show: true, //隐藏X轴轴线
              lineStyle: {
                color: "#3170D9",
                width: 1
              }
            },
            axisTick: {
              show: false //隐藏X轴刻度
            },
            axisLabel: {
              rotate: 30,
              show: true,
              textStyle: {
                color: "#67DDFF", //X轴文字颜色
                fontSize: fontchange(0.1)
              }
            },
            splitArea: {
              show: false
            },
            data: data.xData
          }
        ],
        yAxis: [
          {
            type: "value",
            name: "单位：/亿",
            axisLabel: {
              formatter: "{value}",
              textStyle: {
                color: "#67DDFF",
                fontSize: fontchange(0.12)
              }
            },
            nameTextStyle: {
              color: "#C7F4FE",
              fontSize: fontchange(0.12)
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#3170D9",
                width: 1
              }
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#3170D9",
                width: 1
              }
            }
          }
        ],
        series: [
          {
            name: "PV",
            type: "line",
            smooth: true,
            showAllSymbol: true, //显示所有图形。
            symbol: "circle", //标记的图形为实心圆
            symbolSize: 5, //标记的大小
            itemStyle: {
              color: "#18FDFE"
            },
            lineStyle: {
              show: false,
              color: "#18FDFE",
              width: 1
            },
            data: [489, 456, 523, 512, 535, 552]
          },
          {
            name: "IP",
            type: "line",
            smooth: true,
            showAllSymbol: true, //显示所有图形。
            symbol: "circle", //标记的图形为实心圆
            symbolSize: 5, //标记的大小
            itemStyle: {
              color: "#1AC8B1"
            },
            lineStyle: {
              show: false,
              color: "#1AC8B1",
              width: 1
            },
            data: [221, 274, 262, 205, 348, 249]
          },
          {
            name: "UV",
            type: "line",
            smooth: true,
            showAllSymbol: true, //显示所有图形。
            symbol: "circle", //标记的图形为实心圆
            symbolSize: 5, //标记的大小
            itemStyle: {
              color: "#FFF45C"
            },
            lineStyle: {
              show: false,
              color: "#FFF45C",
              width: 1
            },
            data: [147, 137, 160, 154, 134, 220]
          }
        ]
      };
      myChart.setOption(option);
      echartsCancelLoop(myChart, option, {
        loopSeries: false,
        interval: 2000
      });
      window.addEventListener("resize", function() {
        myChart.resize();
      });
    },
    page1_chart2() {
      let myChart = this.$echarts.init(document.getElementById("page1_chart2"));
      let data = [
        { value: 25, name: "网站联盟" },
        { value: 35, name: "APP联盟" },
        { value: 15, name: "视频OTV" },
        { value: 15, name: "数据模型" },
        { value: 10, name: "其他" }
      ];
      let option = {
        tooltip: {
          show: true,
          trigger: "item"
        },
        legend: {
          top: "7%",
          left: "0",
          textStyle: {
            color: "#fff",
            fontSize: fontchange(0.1)
          },
          itemWidth: fontchange(0.1),
          itemHeight: fontchange(0.1),
          itemGap: fontchange(0.05),
          icon: "rect"
        },
        color: ["#24979C", "#F39856", "#F5C053", "#7CC7EF", "#1D5AA9"],
        series: [
          {
            type: "pie",
            radius: ["0", "73%"],
            center: ["35%", "61%"],
            hoverOffset: 6,
            selectedOffset: 0,
            data: data,
            label: {
              show: false,
              position: "center",
              color: "#fff",
              fontSize: fontchange(0.12),
              lineHeight: fontchange(0.16),
              show: true,
              position: "inner",
              formatter: "{d}%"
            },
            emphasis: {
              label: {
                show: true
              },
              itemStyle: {
                // shadowBlur: 10,
                // shadowOffsetX: 0,
                // shadowColor: "rgba(0, 0, 0, 0.5)",
              }
            }
          }
        ]
      };
      myChart.setOption(option);
      echartsCancelLoop(myChart, option, {
        loopSeries: false,
        interval: 2000
      });
      window.addEventListener("resize", function() {
        myChart.resize();
      });
    },
    page1_chart3() {
      let myChart = this.$echarts.init(document.getElementById("page1_chart3"));
      let dataNum = [110, 77, 66, 50, 42, 33, 25, 22, 17, 10];
      let color = new echarts.graphic.LinearGradient(1, 0, 0, 0, [
        { offset: 0, color: "rgba(24, 254, 254, 1)" },
        { offset: 1, color: "rgba(29, 139, 230, 1)" }
      ]);
      var option = {
        grid: {
          width: "90%",
          left: "10%",
          right: "0",
          bottom: "0%",
          top: "20%",
          containLabel: true
        },
        tooltip: {
          trigger: "axis"
        },
        xAxis: {
          show: true,
          type: "value",
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            textStyle: {
              color: "#67DDFF",
              fontSize: "12"
            }
          }
        },
        yAxis: [
          {
            name: "单位：/亿",
            nameTextStyle: {
              color: "#D0F6FF",
              fontSize: fontchange(0.12)
            },
            nameLocation: "start",
            inverse: true,
            type: "category",
            axisLabel: {
              interval: 0, // 强制显示所有标签,不隔行显示
              show: true,
              textStyle: {
                color: "#1EE6FF",
                fontSize: "12"
              },
              //设置字数限制
              formatter: function(value) {
                if (value.length > 5) {
                  return value.substring(0, 5) + "...";
                } else {
                  return value;
                }
              }
            },
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            data: [
              "广东省",
              "上海",
              "北京",
              "河南省",
              "湖北省",
              "吉林省",
              "湖南省",
              "天津",
              "四川省",
              "海南省"
            ]
          },
          {
            type: "category",
            axisTick: "none",
            axisLine: "none",
            show: true,
            inverse: true,
            axisLabel: {
              // interval: 0, // 强制显示所有标签,不隔行显示
              // textStyle: {
              //   color: "#1EE6FF",
              //   fontSize: "12",
              // },
              // formatter: function (value) {
              //   if (value >= 10000) {
              //     return (value / 10000).toLocaleString() + "家";
              //   } else {
              //     return value.toLocaleString() + "家";
              //   }
              // },
            },
            data: dataNum
          }
        ],
        series: [
          {
            name: "数量(亿)",
            type: "bar",
            showBackground: true,
            backgroundStyle: {
              color: "rgba(0,0,0,0)",
              borderColor: "#0069AC",
              borderWidth: 1
            },
            borderWidth: 1,
            borderColor: "#fff",
            zlevel: 1,
            itemStyle: {
              normal: {
                color: color
              }
            },
            barWidth: 10,
            barGap: "-100%",
            barCategoryGap: "80%",
            data: dataNum
          }
        ]
      };
      myChart.setOption(option);
      echartsCancelLoop(myChart, option, {
        loopSeries: false,
        interval: 2000
      });
      window.addEventListener("resize", function() {
        myChart.resize();
      });
    },
    translateNum1() {
      const that = this;
      var key = 0;
      var TIME = setInterval(() => {
        this.$axios
          .post("/interfaceappjson/distapiprovince")
          .then(function(res) {
            console.log(res, "data");
            that.translateNum = res.data.num;
            that.translateNum = that.formatMoney(that.translateNum, 0);
            that.translateNum = that.translateNum.toString();
          })
          .catch(err => {
            console.log(err);
          });
        key++;

        var ulArr = [];
        for (var i = 0; i < that.translateNum.length; i++) {
          ulArr.push(i);
          if (that.translateNum[i] == ",") {
            $(".numbox ul")
              .eq(i)
              .animate({ top: -10 * 64 + "px" }, "slow", "linear");
          } else {
            $(".numbox ul")
              .eq(i)
              .animate(
                { top: -that.translateNum[i] * 64 + "px" },
                "slow",
                "linear"
              );
          }
        }
        that.ulArr = ulArr;
      }, 5000);
    },
    formatMoney(s, type) {
      if (/[^0-9\.]/.test(s)) return "0";
      if (s == null || s == "") return "0";
      s = s.toString().replace(/^(\d*)$/, "$1.");
      s = (s + "00").replace(/(\d*\.\d\d)\d*/, "$1");
      s = s.replace(".", ",");
      var re = /(\d)(\d{3},)/;
      while (re.test(s)) s = s.replace(re, "$1,$2");
      s = s.replace(/,(\d\d)$/, ".$1");
      if (type == 0) {
        // 不带小数位(默认是有小数位)
        var a = s.split(".");
        if (a[1] == "00") {
          s = a[0];
        }
      }
      return s;
    },
    getData() {
      var that = this;
      this.$axios
        .post("/interfaceappjson/distapiprovince")
        .then(function(res) {
          console.log(res);
          that.translateNum = res.data.num;
          that.translateNum = that.formatMoney(that.translateNum, 0);
          that.cityList = res.data.guourl;
          that.cityList = JSON.parse(that.cityList);
        })
        .catch(err => {
          console.log(err);
        });
    },
    page1_map() {
      let myChart = this.$echarts.init(document.getElementById("page1_map"));
      var geoCoordMap = {
        杭州: [119.5313, 29.8773],
        黄骅: [117.330048, 38.371383],
        上海: [121.4648, 31.2891],
        东莞: [113.8953, 22.901],
        东营: [118.7073, 37.5513],
        中山: [113.4229, 22.478],
        临汾: [111.4783, 36.1615],
        临沂: [118.3118, 35.2936],
        丹东: [124.541, 40.4242],
        丽水: [119.5642, 28.1854],
        乌鲁木齐: [87.9236, 43.5883],
        佛山: [112.8955, 23.1097],
        保定: [115.0488, 39.0948],
        兰州: [103.5901, 36.3043],
        甘肃: [103.5901, 36.3043], //省会
        包头: [110.3467, 41.4899],
        北京: [116.4551, 40.2539],
        北海: [109.314, 21.6211],
        南京: [118.8062, 31.9208],
        江苏: [118.8062, 31.9208], //省会
        南宁: [108.479, 23.1152],
        南昌: [116.0046, 28.6633],
        江西: [116.0046, 28.6633], //省会
        南通: [121.1023, 32.1625],
        厦门: [118.1689, 24.6478],
        台州: [121.1353, 28.6688],
        合肥: [117.29, 32.0581],
        安徽: [117.29, 32.0581], //省会
        呼和浩特: [111.4124, 40.4901],
        内蒙古: [111.4124, 40.4901],
        咸阳: [108.4131, 34.8706],
        哈尔滨: [127.9688, 45.368],
        黑龙江: [127.9688, 45.368], //省会
        唐山: [118.4766, 39.6826],
        嘉兴: [120.9155, 30.6354],
        大同: [113.7854, 39.8035],
        大连: [122.2229, 39.4409],
        天津: [117.4219, 39.4189],
        太原: [112.3352, 37.9413],
        山西: [112.3352, 37.9413], //省会
        威海: [121.9482, 37.1393],
        宁波: [121.5967, 29.6466],
        宝鸡: [107.1826, 34.3433],
        宿迁: [118.5535, 33.7775],
        常州: [119.4543, 31.5582],
        广州: [113.5107, 23.2196],
        广东: [113.5107, 23.2196], //省会
        廊坊: [116.521, 39.0509],
        延安: [109.1052, 36.4252],
        张家口: [115.1477, 40.8527],
        徐州: [117.5208, 34.3268],
        德州: [116.6858, 37.2107],
        惠州: [114.6204, 23.1647],
        成都: [103.9526, 30.7617],
        扬州: [119.4653, 32.8162],
        承德: [117.5757, 41.4075],
        拉萨: [91.1865, 30.1465],
        西藏: [91.1865, 30.1465], //省会
        无锡: [120.3442, 31.5527],
        日照: [119.2786, 35.5023],
        昆明: [102.9199, 25.4663],
        云南: [102.9199, 25.4663], //省会
        // 杭州: [119.5313, 29.8773],
        浙江: [119.5313, 29.8773], //省会
        枣庄: [117.323, 34.8926],
        柳州: [109.3799, 24.9774],
        株洲: [113.5327, 27.0319],
        武汉: [114.3896, 30.6628],
        湖北: [114.3896, 30.6628], //省会
        汕头: [117.1692, 23.3405],
        江门: [112.6318, 22.1484],
        沈阳: [123.1238, 42.1216],
        辽宁: [123.1238, 42.1216], //省会
        沧州: [116.8286, 38.2104],
        河源: [114.917, 23.9722],
        泉州: [118.3228, 25.1147],
        泰安: [117.0264, 36.0516],
        泰州: [120.0586, 32.5525],
        济南: [117.1582, 36.8701], //省会
        山东: [117.1582, 36.8701],
        济宁: [116.8286, 35.3375],
        海口: [110.3893, 19.8516],
        海南: [110.3893, 19.8516], //省会
        淄博: [118.0371, 36.6064],
        淮安: [118.927, 33.4039],
        深圳: [114.5435, 22.5439],
        清远: [112.9175, 24.3292],
        温州: [120.498, 27.8119],
        渭南: [109.7864, 35.0299],
        湖州: [119.8608, 30.7782],
        湘潭: [112.5439, 27.7075],
        滨州: [117.8174, 37.4963],
        潍坊: [119.0918, 36.524],
        烟台: [120.7397, 37.5128],
        玉溪: [101.9312, 23.8898],
        珠海: [113.7305, 22.1155],
        盐城: [120.2234, 33.5577],
        盘锦: [121.9482, 41.0449],
        石家庄: [114.4995, 38.1006],
        河北: [114.4995, 38.1006], //省会
        福州: [119.4543, 25.9222],
        福建: [119.4543, 25.9222], //省会
        秦皇岛: [119.2126, 40.0232],
        绍兴: [120.564, 29.7565],
        聊城: [115.9167, 36.4032],
        肇庆: [112.1265, 23.5822],
        舟山: [122.2559, 30.2234],
        苏州: [120.6519, 31.3989],
        莱芜: [117.6526, 36.2714],
        菏泽: [115.6201, 35.2057],
        营口: [122.4316, 40.4297],
        葫芦岛: [120.1575, 40.578],
        衡水: [115.8838, 37.7161],
        衢州: [118.6853, 28.8666],
        西宁: [101.4038, 36.8207],
        青海: [101.4038, 36.8207], //省会
        西安: [109.1162, 34.2004],
        陕西: [109.1162, 34.2004], //省会
        贵阳: [106.6992, 26.7682],
        贵州: [106.6992, 26.7682], //省会
        连云港: [119.1248, 34.552],
        邢台: [114.8071, 37.2821],
        邯郸: [114.4775, 36.535],
        郑州: [113.4668, 34.6234],
        河南: [113.4668, 34.6234], //省会
        鄂尔多斯: [108.9734, 39.2487],
        重庆: [107.7539, 30.1904],
        金华: [120.0037, 29.1028],
        铜川: [109.0393, 35.1947],
        银川: [106.3586, 38.1775],
        宁夏: [106.3586, 38.1775], //省会
        镇江: [119.4763, 31.9702],
        长春: [125.8154, 44.2584],
        吉林: [125.8154, 44.2584], //省会
        长沙: [113.0823, 28.2568],
        湖南: [113.0823, 28.2568], //省会
        长治: [112.8625, 36.4746],
        阳泉: [113.4778, 38.0951],
        青岛: [120.4651, 36.3373],
        韶关: [113.7964, 24.7028]
      };
      var BJData = [
        [
          {
            name: "杭州"
          },
          {
            name: "杭州",
            value: 200
          }
        ],

        [
          {
            name: "杭州"
          },
          {
            name: "长沙",
            value: 95
          }
        ],
        [
          {
            name: "杭州"
          },
          {
            name: "武汉",
            value: 30
          }
        ],
        [
          {
            name: "杭州"
          },
          {
            name: "南昌",
            value: 20
          }
        ],
        [
          {
            name: "杭州"
          },
          {
            name: "合肥",
            value: 70
          }
        ],
        [
          {
            name: "杭州"
          },
          {
            name: "南京",
            value: 60
          }
        ],
        [
          {
            name: "杭州"
          },
          {
            name: "福州",
            value: 50
          }
        ],
        [
          {
            name: "杭州"
          },
          {
            name: "上海",
            value: 100
          }
        ],
        [
          {
            name: "杭州"
          },
          {
            name: "深圳",
            value: 100
          }
        ],
        [
          {
            name: "杭州"
          },
          {
            name: "北京",
            value: 200
          }
        ],
        [
          {
            name: "杭州"
          },
          {
            name: "呼和浩特",
            value: 90
          }
        ],
        [
          {
            name: "杭州"
          },
          {
            name: "哈尔滨",
            value: 90
          }
        ],
        [
          {
            name: "杭州"
          },
          {
            name: "石家庄",
            value: 90
          }
        ],
        [
          {
            name: "杭州"
          },
          {
            name: "昆明",
            value: 30
          }
        ],
        [
          {
            name: "杭州"
          },
          {
            name: "长春",
            value: 40
          }
        ],
        [
          {
            name: "杭州"
          },
          {
            name: "重庆",
            value: 40
          }
        ],
        [
          {
            name: "杭州"
          },
          {
            name: "贵阳",
            value: 50
          }
        ],
        [
          {
            name: "杭州"
          },
          {
            name: "南宁",
            value: 30
          }
        ],
        [
          {
            name: "杭州"
          },
          {
            name: "济南",
            value: 10
          }
        ],
        [
          {
            name: "杭州"
          },
          {
            name: "太原",
            value: 40
          }
        ],
        [
          {
            name: "杭州"
          },
          {
            name: "西安",
            value: 60
          }
        ],
        [
          {
            name: "杭州"
          },
          {
            name: "武汉",
            value: 50
          }
        ],
        [
          {
            name: "杭州"
          },
          {
            name: "南京",
            value: 30
          }
        ],
        [
          {
            name: "杭州"
          },
          {
            name: "沈阳",
            value: 20
          }
        ],
        [
          {
            name: "杭州"
          },
          {
            name: "成都",
            value: 10
          }
        ],
        [
          {
            name: "杭州"
          },
          {
            name: "新疆玛纳斯基地",
            value: 10
          }
        ],
        [
          {
            name: "杭州"
          },
          {
            name: "乌鲁木齐",
            value: 10
          }
        ],
        [
          {
            name: "杭州"
          },
          {
            name: "拉萨",
            value: 10
          }
        ]
      ];
      var convertData = function(data) {
        var res = [];
        for (var i = 0; i < data.length; i++) {
          var dataItem = data[i];
          var fromCoord = geoCoordMap[dataItem[0].name];
          var toCoord = geoCoordMap[dataItem[1].name];
          if (fromCoord && toCoord) {
            res.push({
              fromName: dataItem[0].name,
              toName: dataItem[1].name,
              coords: [fromCoord, toCoord],
              value: dataItem[1].value
            });
          }
        }
        return res;
      };
      var series = [];
      [["杭州", BJData]].forEach(function(item, i) {
        series.push(
          {
            type: "map",
            map: "china",
            geoIndex: 0,
            data: [
              {
                name: "杭州",
                selected: true,
                itemStyle: {
                  areaColor: {
                    // type: "radial",
                    // x: 0.5,
                    // y: 0.5,
                    // r: 0.5,
                    // colorStops: [
                    //   {
                    //     offset: 0,
                    //     color: "rgba(0,255,255, 0.1)",
                    //   },
                    //   {
                    //     offset: 1,
                    //     color: "rgba(0,255,255, 0.7)",
                    //   },
                    // ],
                    // global: false, // 缺省为 false
                  }
                }
              } // selected:true 默认选中
            ]
          },
          {
            name: "杭州",
            type: "lines",
            zlevel: 5,
            effect: {
              show: true,
              period: 2, //箭头指向速度，值越小速度越快
              trailLength: 0.2, //特效尾迹长度[0,1]值越大，尾迹越长重
              symbol: "arrow", //箭头图标
              symbolSize: 5 //图标大小
            },
            lineStyle: {
              normal: {
                color: "#ffcc00",
                width: 1, //线条宽度
                opacity: 0.1, //尾迹线条透明度
                curveness: 0.3 //尾迹线条曲直度
              }
            },
            data: convertData(item[1])
          },
          {
            name: "杭州",
            type: "effectScatter",
            coordinateSystem: "geo",
            zlevel: 6,
            symbolSize: 10,
            showEffectOn: "render",
            rippleEffect: {
              scale: 8,
              color: "#25CEF3", //圆圈颜色
              brushType: "stroke"
            },
            hoverAnimation: true,
            label: {
              normal: {
                fontSize: 12,
                formatter: "{b}", //迁入城市
                position: "right",
                show: true
              }
            },
            itemStyle: {
              normal: {
                color: "#FFCC00" //迁入城市文字
                // shadowBlur: 20,
                // shadowColor: "#333",
              }
            },

            // symbol: "circle",
            // symbolSize: function (val) {
            //   return 1;
            // },

            data: item[1].map(function(dataItem) {
              return {
                name: dataItem[0].name,
                value: geoCoordMap[dataItem[0].name].concat([dataItem[0].value])
              };
            })
          }
          //被攻击点
          // {
          //   type: "scatter",
          //   symbolSize: 10,
          //   showEffectOn: "render",
          //   rippleEffect: {
          //     scale: 10,
          //     color: "#25CEF3", //圆圈颜色
          //     brushType: "stroke",
          //   },
          //   coordinateSystem: "geo",
          //   zlevel: 5,
          //   // rippleEffect: {
          //   //   period: 4,
          //   //   brushType: "stroke",
          //   //   scale: 4,
          //   // },
          //   label: {
          //     normal: {
          //       show: true,
          //       position: "right",
          //       color: "#00ffff",
          //       formatter: "{b}",
          //       textStyle: {
          //         color: "#000", //中心点 文字颜色
          //       },
          //     },
          //     emphasis: {
          //       show: true,
          //     },
          //   },
          //   symbol: "circle",
          //   symbolSize: 10,
          //   itemStyle: {
          //     normal: {
          //       color: "#00ffff",
          //       shadowBlur: 1,
          //     },
          //   },
          //   data: [
          //     {
          //       name: item[0],
          //       value: geoCoordMap[item[0]].concat([100]),
          //     },
          //   ],
          // }
        );
      });
      var option = {
        tooltip: {
          trigger: "item",
          transitionDuration: 0,
          axisPointer: {
            type: "shadow"
          },
          formatter: function(params) {
            if (params.seriesType == "scatter" && params.name != tempData[0]) {
              return (
                params.seriesName + "流量动向"
                // params.data.name +
                // "<br />数量：" +
                // params.data.value[2]
              );
            } else if (params.seriesType == "lines") {
              return (
                params.data.fromName + "流量动向"
                // params.data.toName +
                // "<br />数量：" +
                // params.data.value
              );
            } else {
              return params.name;
            }
          }
        },
        geo: {
          map: "china",
          zoom: 1.25,
          zlevel: 3,
          label: {
            normal: {
              //地图省份名不显示
              show: true,
              color: "#fff"
            },
            emphasis: {
              //鼠标经过地图省份名 显示
              show: true,
              color: "#fff"
            }
          },
          roam: true,
          itemStyle: {
            normal: {
              // areaColor: "rgba(136, 202, 255, 1)",
              areaColor: {
                type: "radial",
                x: 0.5,
                y: 0.5,
                r: 0.8,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(147, 235, 248, 0)" // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(147, 235, 248, .5)" // 100% 处的颜色
                  }
                ],
                globalCoord: false // 缺省为 false
              },
              borderColor: "rgba(147, 235, 248, 1)",
              shadowColor: "rgba(128, 217, 248, 1)",
              shadowOffsetX: 0,
              shadowOffsetY: 10,
              shadowBlur: 10
            },
            emphasis: {
              areaColor: "rgba(38, 87, 185, 1)",
              borderWidth: 0
            }
          }
        },
        series: series
      };
      myChart.setOption(option);
      window.addEventListener("resize", function() {
        myChart.resize();
      });
    },
    page1_chart4() {
      let myChart = this.$echarts.init(document.getElementById("page1_chart4"));
      let data = [
        {
          value: [16, 12, 11, 18, 9, 14, 10]
        }
      ];
      let option = {
        tooltip: {
          //雷达图的tooltip不会超出div，也可以设置position属性，position定位的tooltip 不会随着鼠标移动而位置变化，不友好
          confine: true,
          enterable: true //鼠标是否可以移动到tooltip区域内
        },
        radar: {
          name: {
            textStyle: {
              color: "#fff",
              fontSize: 10
            }
          },
          nameGap: 6,
          shape: "polygon",
          center: ["50%", "50%"],
          radius: "80%",
          startAngle: 120,
          scale: true,
          axisLine: {
            show: false
          },
          splitLine: {
            show: true,
            lineStyle: {
              width: 1,
              color: "#18FDFE" // 设置网格的颜色
            }
          },
          indicator: [
            {
              name: "Andriod",
              max: 20
            },
            {
              name: "Andriod平板",
              max: 20
            },
            {
              name: "智能TV",
              max: 20
            },
            {
              name: "电脑",
              max: 20
            },
            {
              name: "iPad",
              max: 20
            },
            {
              name: "ios",
              max: 20
            },
            {
              name: "其他",
              max: 20
            }
          ],
          splitArea: {
            show: true,
            areaStyle: {
              color: [
                "rgba(24,253,254,0.5)",
                "rgba(24,253,254,0.4)",
                "rgba(24,253,254,0.3)",
                "rgba(24,253,254,0.2)",
                "rgba(24,253,254,0.1)"
              ]
            }
          }
        },
        grid: {
          position: "center"
        },
        polar: {
          center: ["50%", "50%"], // 默认全局居中
          radius: "0%"
        },
        angleAxis: {
          min: 0,
          interval: 5,
          clockwise: false,
          axisTick: {
            show: false
          },
          axisLabel: {
            show: false
          },
          axisLine: {
            show: false
          },
          splitLine: {
            show: false
          }
        },
        radiusAxis: {
          min: 0,
          interval: 20,
          splitLine: {
            show: false
          }
        },
        series: [
          {
            name: "终端占比(%)",
            type: "radar",
            symbol: "circle", // 拐点的样式，还可以取值'rect','angle'等
            symbolSize: 2, // 拐点的大小
            itemStyle: {
              normal: {
                color: "#FFE500"
              }
            },
            areaStyle: {
              normal: {
                color: "none"
              }
            },
            lineStyle: {
              width: 2,
              color: "#FFE500"
            },
            label: {
              normal: {
                show: true,
                formatter: params => {
                  return params.value;
                },
                color: "#FFE500",
                fontSize: 10
              }
            },
            data: data
          }
        ]
      };
      myChart.setOption(option);
      window.addEventListener("resize", function() {
        myChart.resize();
      });
    }
  }
};
</script>
<style lang="less" scoped>
@import "../style/flow.less";
</style>